import { render, staticRenderFns } from "./TheWarehouse.vue?vue&type=template&id=c0bc6f92&"
import script from "./TheWarehouse.vue?vue&type=script&lang=js&"
export * from "./TheWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports